import React from 'react'
import clsx from 'clsx'
import styles from './UIGameDice.module.scss'
import {EventDiceEnum} from '@colonist/game-base-types'
import DiceEventBarbarian from '@static/images/dice_event_barbarian.svg'
import DiceEventScience from '@static/images/dice_event_science.svg'
import DiceEventTrade from '@static/images/dice_event_trade.svg'
import DiceEventPolitics from '@static/images/dice_event_politics.svg'
import Dice1 from '@static/images/dice_1.svg'
import Dice2 from '@static/images/dice_2.svg'
import Dice3 from '@static/images/dice_3.svg'
import Dice4 from '@static/images/dice_4.svg'
import Dice5 from '@static/images/dice_5.svg'
import Dice6 from '@static/images/dice_6.svg'
import DiceRed1 from '@static/images/dice_red_1.svg'
import DiceRed2 from '@static/images/dice_red_2.svg'
import DiceRed3 from '@static/images/dice_red_3.svg'
import DiceRed4 from '@static/images/dice_red_4.svg'
import DiceRed5 from '@static/images/dice_red_5.svg'
import DiceRed6 from '@static/images/dice_red_6.svg'
import {ImageURL} from '@colonist/types'

export type DiceType = 'standardWhite' | 'standardRed' | 'event'
export interface UIGameDiceProps {
    value: number
    type: DiceType
    active: boolean
    onClick?: VoidFunction
    className?: string
}

function getDiceImage(value: number, type: DiceType): ImageURL {
    switch(type) {
        case 'standardWhite': return getNormalDiceImage(value, false)
        case 'standardRed': return getNormalDiceImage(value, true)
        case 'event': return getEventDiceImage(value)
    }
}

type DieFace = 1 | 2 | 3 | 4 | 5 | 6
const diceByFace: Record<DieFace, ImageURL> = {
    1: Dice1,
    2: Dice2,
    3: Dice3,
    4: Dice4,
    5: Dice5,
    6: Dice6,
} as const

const redDiceByFace: Record<DieFace, ImageURL> = {
    1: DiceRed1,
    2: DiceRed2,
    3: DiceRed3,
    4: DiceRed4,
    5: DiceRed5,
    6: DiceRed6,
} as const

function getNormalDiceImage(value: number, red: boolean): ImageURL {
    const allowedDiceNumbers = [1, 2, 3, 4, 5, 6]
    if(!allowedDiceNumbers.includes(value)) value = 1

    return (red ? redDiceByFace : diceByFace)[value]
}

function getEventDiceImage(value: number): ImageURL {
    switch(value) {
        case 1:
        case 2:
        case 3:
            return DiceEventBarbarian
        case EventDiceEnum.Science:
            return DiceEventScience
        case EventDiceEnum.Trade:
            return DiceEventTrade
        case EventDiceEnum.Politics:
            return DiceEventPolitics
    }

    return DiceEventBarbarian
}

export function UIGameDice({
    value,
    type,
    active,
    onClick,
    className,
}: UIGameDiceProps) {
    const diceImage = getDiceImage(value, type)
    return (
        <div className={clsx(styles.diceWrapper, {[styles.pulsing]: active}, className)} onClick={onClick}>
            <img
                draggable={false}
                className={clsx(styles.dice, {[styles.inactive]: !active})}
                src={diceImage}
            />
        </div>
    )
}
